/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore'], function(backbone, _) {
    /**
     * @param {StartFileWidgetModel} model
     * @constructor
     */
    var StartFileWidget = function(model) {
        this.model = model;
        var _this = this;

        if (!this.model.get('product')) {
            var product = this.model.get('products').first();
            this.model.set('product', product);
        }
        if (!this.model.get('startFile')) {
            var startFile = this.model
                .get('product')
                .get('startFiles')
                .first();
            this.model.set('startFile', startFile);
        }

        _.extend(this, backbone.Events);
        this.listenTo(this.model, 'StartFileWidget:change', function(productSlug, filter) {
            _this.findStartFile(productSlug, filter);
        });
    };

    StartFileWidget.prototype = {
        /**
         * @param {string} productSlug
         * @param {StartFileModel} filter
         */
        findStartFile: function(productSlug, filter) {
            var product = this.model.get('products').get(productSlug);
            this.model.set('product', product);

            var startFile = product.get('startFiles').findWhere({
                type: filter.get('type'),
                filter: filter.get('filter')
            });
            if (!startFile) {
                startFile = product.get('startFiles').findWhere({
                    type: filter.get('type')
                });
            }
            if (!startFile) {
                startFile = product.get('startFiles').findWhere({
                    filter: filter.get('filter')
                });
            }
            if (!startFile) {
                startFile = product.get('startFiles').first();
            }
            this.model.set('startFile', startFile ? startFile : null);
        }
    };

    return StartFileWidget;
});
